import moment from 'moment'
import _ from 'lodash'

export default landingOffreRentree2018Ctrl

/** @ngInject */
function landingOffreRentree2018Ctrl($state, $stateParams, $scope, $interval, ContactTelephone, gaEventsService) {
    $scope.contactTelephone = ContactTelephone
    $scope.gaEventsService = gaEventsService
    $scope.params = $state.params
    $scope.partnerOfferEnd = moment('2018-10-15')
    $scope.displayCountdown = 10
    $scope.city = $stateParams.ville
    $scope.prep = ['d\'', 'd’'].indexOf($stateParams.prep) > -1 ? $stateParams.prep : `${$stateParams.prep} `

    const logoMapping = {
        'aix': 'logo-aix.svg',
        'le mans': 'logo-le-mans.svg',
        'montpellier': 'logo-montpellier.svg',
        'nancy': 'logo-nancy.svg',
        'nantes': 'logo-nantes.svg',
        'nice': 'logo-nice.svg',
        'nimes': 'logo-nimes.svg',
        'nîmes': 'logo-nimes.svg',
        'perpignan': 'logo-perpignan.svg',
        'toulon': 'logo-toulon.svg',
        'toulouse': 'logo-toulouse.svg',
    }

    $scope.logo = _.get(logoMapping, _.toLower($stateParams.ville), 'logo-ag-hcplus.svg')

    $scope.countdownDetail = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    }

    $interval(() => {
        const countdown = moment.duration(moment($scope.partnerOfferEnd).add(1, 'days').diff())
        $scope.countdownDetail = {
            days: Math.trunc(countdown.asDays()),
            hours: _.padStart(countdown.hours(), 2, '0'),
            minutes: _.padStart(countdown.minutes(), 2, '0'),
            seconds: _.padStart(countdown.seconds(), 2, '0'),
            asSeconds: Math.trunc(countdown.asSeconds()),
        }
    }, 1000, 0)
}



// WEBPACK FOOTER //
// ./src/states/subscriptionLanding/landingOffreRentree2018.js